import React from 'react';

class SeatSelectionHeader extends React.Component {
  render() {
    const { title, maxSeats, selectedCount, onRefresh, onClose, refreshing } = this.props;

    return (
      <div className="seat-selection-header">
        <div className="header-left">
          <h2 className="header-title">
            {title || 'Seats Selection'}
            <span className="max-seats-indicator">
              (Max seats to select: {maxSeats})
            </span>
          </h2>
        </div>
        <div className="header-right">
          <span className="selected-count">
            {selectedCount} / {maxSeats} selected
          </span>
          <button
            className={'btn-refresh' + (refreshing ? ' refreshing' : '')}
            onClick={onRefresh}
            title="Refresh seat availability"
            disabled={refreshing}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
            </svg>
          </button>
          <button
            className="btn-close"
            onClick={onClose}
            title="Close"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}

export default SeatSelectionHeader;
